import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { RadioCardWrapper } from 'components/forms';
import styles from './Form.module.scss';

export const formFields = [
  {
    label: 'form.field.label.backend.app',
    description: 'form.field.description.backend.app',
    name: 'isOnlyBackEnd',
    value: 'yes',
  },
  {
    label: 'form.field.label.app.with.ui',
    description: 'form.field.description.app.with.ui',
    name: 'isOnlyBackEnd',
    value: 'no',
  },
];

const AppTypeForm: FC = (props) => (
  <div className={styles.fieldsContainer}>
    {formFields.map((field: any) => (
      <Field {...field} {...props} type='radio' component={RadioCardWrapper} key={field.value} />
    ))}
  </div>
);

export default AppTypeForm;
